import type { Column } from '@/types'
import { getColumnKeyLabels } from '@/utils/columnKeys'

interface SidebarColumnItemProps {
  column: Column
  onClick: () => void
}

function getKeyColor(key: string) {
  if (key === 'PK') return '#D97706'
  if (key === 'FK') return '#4F46E5'
  if (key === 'UQ') return '#059669'
  return 'var(--text-dim)'
}

export function SidebarColumnItem({ column, onClick }: SidebarColumnItemProps) {
  const labels = getColumnKeyLabels(column)
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-full items-center gap-2 px-3 py-1 pl-8 text-left text-[10px] transition-colors"
      style={{ color: 'var(--text-dim)' }}
      onMouseEnter={(event) => {
        event.currentTarget.style.background = 'var(--sb-hover)'
        event.currentTarget.style.color = 'var(--text-muted)'
      }}
      onMouseLeave={(event) => {
        event.currentTarget.style.background = 'transparent'
        event.currentTarget.style.color = 'var(--text-dim)'
      }}
    >
      <span
        className="inline-flex min-w-[20px] shrink-0 justify-center text-[8px] font-bold"
        style={{ color: getKeyColor(labels[0] || '') }}
      >
        {labels.join('/')}
      </span>
      <span className="min-w-0 flex-1 truncate">{column.name}</span>
      <span className="shrink-0 text-[9px]" style={{ color: 'var(--text-dim)' }}>
        {column.type}
      </span>
    </button>
  )
}
